// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__K1SDL","colBig":"styles_colBig__3B4T-","colSmall":"styles_colSmall__Ih5xs"};